import React from 'react';
import PropTypes from 'prop-types';

import debounce from 'lodash/debounce';

import AdditionalEmails from './additional_emails';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Tooltip from 'components/tooltip';
import * as api from 'helpers/api';
import { pluralize } from 'helpers/formatters/string_formats';

export default class Email extends React.Component {
  static propTypes = {
    contact: PropTypes.shape({
      additionalEmails: PropTypes.array.isRequired,
      email: PropTypes.string,
      id: PropTypes.number,
    }).isRequired,
    onChange: PropTypes.func.isRequired
  }

  state = {};

  debouncedDetectDuplicateEmails = debounce(async (email) => {
    const duplicates = await api.get('/backoffice/contacts/duplicates', {
      params: {
        email,
        id: this.props.contact.id
      }
    });

    this.setState({ duplicates });
  }, 500);

  handleChange = (email) => {
    this.debouncedDetectDuplicateEmails(email);
    this.props.onChange({ email });
  }

  render() {
    return <React.Fragment>
      <ManagedFormGroup
        aria-label="email"
        autoComplete="off"
        label="Email"
        name="email"
        placeholder="Type email"
        required
        value={this.props.contact.email || ''}
        onValueChange={this.handleChange}
      />

      {this.renderDuplicates()}

      <AdditionalEmails
        additionalEmails={this.props.contact.additionalEmails}
        onChange={additionalEmails => this.props.onChange({ additionalEmails })}
      />
    </React.Fragment>;
  }

  renderDuplicates() {
    const { duplicates } = this.state;
    if (!duplicates || duplicates.length === 0) {
      return;
    }

    const firstContact = duplicates[0];
    const otherContacts = duplicates.slice(1);

    const tooltipContent = (
      <div className="p-2">
        {otherContacts.map(contact => (
          <div className="mb-1" key={contact.id}>{contact.name}</div>
        ))}
      </div>
    );

    const matches = (
      <>
        <div className="mb-2" key={firstContact.id} name="duplicate">
          <div className="contact-initials-bubble mr-2">
            <span className="text">{firstContact.initials}</span>
          </div>
          <span>{firstContact.name}</span>
        </div>
        {otherContacts.length > 0 && (
          <Tooltip content={tooltipContent} dark name="duplicates-tooltip" placement="right">
            <button
              className="btn btn-link d-inline-flex align-items-center ml-1 p-0"
            >
              and {pluralize(otherContacts.length, 'other contact', 's')}
            </button>
          </Tooltip>
        )}
      </>
    );


    return (
      <div
        aria-label="duplicateEmails"
        className="panel panel-warning panel-accent dashed-border"
        name="duplicates-panel"
      >
        <div className="panel-body">
          <div className="text-right">
            <button className="close" name="dismiss" onClick={() => this.setState({ duplicates: [] })}>
              <span>&times;</span>
            </button>
          </div>
          <div className="text-center">
            <p>
              <span>It looks like a contact with the email </span>
              <strong>{duplicates[0].email} </strong>
              <span>already exists</span>
            </p>
            {matches}
          </div>
        </div>
      </div>
    );
  }
}
